import React, { Component } from "react";
import TextBox from "../../../default/TextBox";

export default function Sponsored(prop) {
  const data = prop.data;
  return (
    <section className="section section-family sponsored ">
      <h2 className="container">
        <span
          className="section-title sponsored-title color-dark "
          style={{ textAlign: "center" }}
        >
          SPONSOR
        </span>
      </h2>
      <div className="container">
        {/* <TextBox
          title={SponsorText.title}
          text={SponsorText.text}
          class={SponsorText.class}
        /> */}
        {/* <div className="section-con-btn ">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSf5t9WroVHUFfZAxE8MMrLYzNetIsPxn0AgnJdbYGYaXi6ftg/viewform?usp=dialog"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="btn-style2 waves-effect waves-red font-color-red ">
              문의하기
            </span>
          </a>
        </div> */}
      </div>
      <div className="section-con sponsored-con container">
        {data.map((con, i) => {
          return (
            <SponserBox src={con.src} alt={con.alt} link={con.link} key={i} />
          );
        })}
      </div>
      {/* <div
        className="section-con-txt container box-con-txt"
        style={{
          width: "50%",
          maxWidth: "700px",
          padding: "50px 2% 30px",
          minHeight: "auto",
        }}
      >
        <div style={{ display: "inline-block", marginTop: "0 " }}>
          <p className="b" style={{ marginBottom: "2%" }}>
            MAX THE CREATIVE 4th 후원사 마감
          </p>
        </div>
        <div
          className=" section-con-btn"
          style={{
            display: "inline-block",
            padding: "2% 0",
            textAlign: "center",
            marginTop: "0",
          }}
        >
         
          <span
            className="btn-style2 font-color-red "
            style={{ fontWeight: "normal" }}
          >
            후원사 모집이 마감되었습니다. 감사합니다.
          </span>
        </div> 
      </div>*/}
    </section>
  );
}

const SponserBox = (props) => {
  return (
    <div className="sponsored-con-box">
      <div className="family-logo">
        <a href={props.link} target="_blank">
          <img src={props.src} alt={props.alt} />
        </a>
      </div>
    </div>
  );
};

// DATA
const SponsorText = {
  class: "text-center",
  title: "SPONSOR & AFFILIATE",
  text: (
    <>
      MAX The Creative 2026을 함께 빛내주실 후원사 및 <br className="m" />
      제휴사를 모집하고 있습니다. <br />
      세션 참여, 부스 운영, 자사 브랜딩 및 홍보를 위한 상품 지원 등{" "}
      <br className="m" />
      다양한 협업을 기다리고 있습니다. <br />
      문의하기를 통해 남겨주시면 운영사무국에서 별도로 <br className="m" />
      연락드릴 예정이오니 많은 관심 부탁드립니다.
    </>
  ),
};
